var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cookie-modal" }, [
    _c("div", { staticClass: "cookie-content" }, [
      _c(
        "svg",
        {
          staticClass: "cookie-icon",
          attrs: {
            width: "38",
            height: "38",
            viewBox: "0 0 38 38",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }
        },
        [
          _c("path", {
            attrs: {
              d:
                "M19 2.89917e-05C8.50476 2.89917e-05 0 8.50442 0 19C0 29.4956 8.5044 38 19 38C29.4956 38 38 29.4956 38 19C38 18.2331 37.9445 17.4786 37.8516 16.73C37.2207 17.1633 36.4538 17.4167 35.625 17.4167C33.918 17.4167 32.4771 16.3281 31.9201 14.819C30.9305 15.4499 29.7618 15.8333 28.5 15.8333C24.9994 15.8333 22.1667 13.0006 22.1667 9.5C22.1667 8.33721 22.5007 7.26108 23.0513 6.32094C23.0202 6.32731 22.9891 6.33332 22.9584 6.33332C20.7689 6.33332 19 4.56442 19 2.37498C19 1.49037 19.2969 0.6867 19.7857 0.0307477C19.5256 0.0187316 19.2661 2.89917e-05 19 2.89917e-05ZM30.875 2.89917e-05C29.5638 2.89917e-05 28.5 1.06385 28.5 2.37503C28.5 3.68621 29.5638 4.75003 30.875 4.75003C32.1862 4.75003 33.25 3.68621 33.25 2.37503C33.25 1.06385 32.1862 2.89917e-05 30.875 2.89917e-05ZM15.9139 3.46355C16.2295 5.5046 17.4169 7.2611 19.0746 8.34962C19.0251 8.72708 19.0003 9.11655 19.0003 9.50002C19.0003 14.7388 23.2616 19 28.5003 19C29.286 19 30.0713 18.9011 30.8258 18.7031C31.9084 19.6928 33.275 20.3484 34.7595 20.5338C33.9865 28.5495 27.2139 34.8336 19.0003 34.8336C10.2673 34.8336 3.167 27.7333 3.167 19.0003C3.167 11.325 8.65884 4.90483 15.9139 3.46355ZM28.5 7.91669C27.6281 7.91669 26.9167 8.62813 26.9167 9.50002C26.9167 10.3719 27.6281 11.0834 28.5 11.0834C29.3719 11.0834 30.0833 10.3719 30.0833 9.50002C30.0833 8.62813 29.3719 7.91669 28.5 7.91669ZM15.8333 9.50002C14.9614 9.50002 14.25 10.2115 14.25 11.0834C14.25 11.9552 14.9614 12.6667 15.8333 12.6667C16.7052 12.6667 17.4167 11.9552 17.4167 11.0834C17.4167 10.2115 16.7052 9.50002 15.8333 9.50002ZM36.4167 9.50002C35.5448 9.50002 34.8333 10.2115 34.8333 11.0834C34.8333 11.9552 35.5448 12.6667 36.4167 12.6667C37.2886 12.6667 38 11.9552 38 11.0834C38 10.2115 37.2886 9.50002 36.4167 9.50002ZM11.0833 14.25C9.3328 14.25 7.91667 15.6662 7.91667 17.4167C7.91667 19.1672 9.3328 20.5833 11.0833 20.5833C12.8339 20.5833 14.25 19.1672 14.25 17.4167C14.25 15.6662 12.8339 14.25 11.0833 14.25ZM19 17.4167C18.1281 17.4167 17.4167 18.1281 17.4167 19C17.4167 19.8719 18.1281 20.5833 19 20.5833C19.8719 20.5833 20.5833 19.8719 20.5833 19C20.5833 18.1281 19.8719 17.4167 19 17.4167ZM13.4583 23.75C12.1472 23.75 11.0833 24.8138 11.0833 26.125C11.0833 27.4362 12.1472 28.5 13.4583 28.5C14.7695 28.5 15.8333 27.4362 15.8333 26.125C15.8333 24.8138 14.7695 23.75 13.4583 23.75ZM24.5417 25.3333C23.2305 25.3333 22.1667 26.3972 22.1667 27.7083C22.1667 29.0195 23.2305 30.0833 24.5417 30.0833C25.8528 30.0833 26.9167 29.0195 26.9167 27.7083C26.9167 26.3972 25.8528 25.3333 24.5417 25.3333Z",
              fill: "white"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "cookie-text" },
        [
          _vm._v(
            "\n      Our site uses cookies to enhance your the experience and measure\n      traffic.\n      "
          ),
          _c(
            "router-link",
            { staticClass: "cookie-link", attrs: { to: "/privacy-policy" } },
            [_vm._v("Learn more")]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "cookie-buttons" }, [
      _c("button", { staticClass: "button", on: { click: _vm.setCookie } }, [
        _vm._v("Got it!")
      ]),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "secondary-button", on: { click: _vm.setCookie } },
        [_vm._v("No Thanks")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }